<template>
  <v-layout>
    <v-col v-if="Order.isForm" cols :sm="6" class="pa-0">
      <v-form v-model="Order.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.order") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-statusOrder
                  v-model="Order.obj.status"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-text-field color="primary" v-model="Order.obj.note">
                  <template #label>
                    {{ $t(`table.note`) }}
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Order.isValid"
              @click="Order.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ Order.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Order",
  }),
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnUpdate() {
      const { code } = await this.fnPut({
        url: `/v1/admin/order/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
